import { useEffect } from 'react';
import { useUiStore } from '../store/ui.js';

/**
 * 창·탭 제목.
 *
 * Electron은 document.title을 창 제목으로 쓴다. 위장 중에는 작업표시줄에
 * '속닥'이 떠 있으면 안 되므로 중립적인 문서 이름으로 바꾼다.
 */
const STEALTH_TITLE = '분기_실적_취합_v3.xlsx';
const APP_TITLE = 'sokdaq';

export function useWindowTitle(): void {
  const stealth = useUiStore((s) => s.view === 'stealth');

  const unread = useUiStore((s) => s.unread);

  useEffect(() => {
    if (stealth) {
      // 위장 중에는 개수도 붙이지 않는다. '(3) 분기_실적...'은 수상하다.
      document.title = STEALTH_TITLE;
      return;
    }
    document.title = unread > 0 ? `(${unread}) ${APP_TITLE}` : APP_TITLE;
  }, [stealth, unread]);
}
